import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '../../app-badge'
import type { BadgeTutorTaskProps } from '../types/interfaces'

import { TaskStatus } from '@brighterly/lib-core-types/tutor/enums'

import { useListsStore } from '@shared/model'

import { useBadgeFromStatus } from '../../app-badge'

interface BadgeTutorTaskOptions {
  props: BadgeTutorTaskProps
}

interface BadgeTutorTaskReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

const STATUS_COLORS: Partial<Record<TaskStatus, AppBadgeColor>> = {
  [TaskStatus.Completed]: 'emerald',
  [TaskStatus.Planned]: 'blue',
  [TaskStatus.Canceled]: 'slate',
}

export const useBadgeTutorTask = ({ props }: BadgeTutorTaskOptions): BadgeTutorTaskReturn => {
  const listsStore = useListsStore()

  return useBadgeFromStatus<TaskStatus>({
    status: () => props.status,
    colors: STATUS_COLORS,
    labels: () => listsStore.getLists?.tutor_task.status,
  })
}
